import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';
import Swal from 'sweetalert2';

// Set actions for dropdown menu on table rows
export default function(tableId) {

  $('.action-dropdown').off().click(function() {
    let action_links = JSON.parse($(this).closest('tr').attr('data-action-links'));
    let recordId = $(this).closest('tr').attr('data-record-id');
    let top = $(this).offset().top + 40;
    let bottom = $(document).height() - $(this).offset().top + 10;
    let left = $(this).offset().left - 240;

    // Remove existing menus
    if ($('.table-menu[data-record-id=\'' + recordId + '\']').length > 0) {
      $('.table-menu').remove();

    } else {

      $('.table-menu').remove();

      // Build menu of action items
      let menu = "<div id=\'table_menu_" + recordId + "\' class=\'menu-container table-menu d-block position-absolute\' "
      menu += "data-record-id=\'" + recordId + "\' ";
      if (bottom < 350) {
        menu += "style=\'max-width: 283px; max-height: 450px; left: " + left + "px; bottom: " + bottom + "px;\'>";
      } else {
        menu += "style=\'max-width: 283px; max-height: 450px; left: " + left + "px; top: " + top + "px;\'>";
      }
      $.each(action_links, function(index, l) {
        let classList = "menu-item";
        if (typeof l["class"] !== "undefined") {classList += " " + l["class"]};
        if (typeof l["href"] !== "undefined") {
          menu += "<a href=\'" + l["href"] + "\' class=\'" + classList + "\'";
        } else {
          menu += "<div class=\'" + classList + "\'";
        }
        if (typeof l["turbo_stream"] !== "undefined") {menu += " data-turbo-stream=\'" + l["turbo_stream"] + "\'"}
        if (typeof l["method"] !== "undefined") {menu += " data-turbo-method=\'" + l["method"] + "\'"}
        if (typeof l["remote"] !== "undefined") {menu += " data-remote=\'" + l["remote"] + "\'"}
        if (typeof l["target"] !== "undefined") {menu += " target=\'" + l["target"] + "\'"}
        if (typeof l["confirm"] !== "undefined") {menu += " data-turbo-confirm=\'" + l["confirm"] + "\'"}
        if (typeof l["href"] !== "undefined") {
          menu += ">" + l["display"] + "</a>";
        } else {
          menu += ">" + l["display"] + "</div>";
        }
      })
      menu += "</div>";
      $('body').append(menu);

      // Close menu on click
      $('.menu-item').click(function() {
        $(this).closest('.table-menu').remove();
      })

      // Confirm and delete an item on click
      $('.delete-record').click(function(e) {
        let updatedTableId = $('#' + tableId).attr('id');
        let deleteUrl = $('#' + tableId).attr('data-delete-url');
        let recordId = $(this).closest('.menu-container').attr('data-record-id');
        deleteUrl = deleteUrl.replace(':record_id', recordId);
        return Swal.fire({
          title: "Are you sure?",
          text: "Confirm that you would like to remove this record",
          animation: false,
          focusConfirm: false,
          showCancelButton: true,
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          reverseButtons: true,
          customClass: {
            confirmButton: 'btn btn-danger',
            cancelButton: 'btn btn-tertiary',
            popup: 'animated fadeIn faster'
          },
        }).then((result) => {              
          if (result.value) {
            $.ajax({
              type: 'DELETE',
              url: deleteUrl,
              beforeSend: function(xhr) {xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
              success(result) { 
                $('#' + updatedTableId).DataTable().ajax.reload();
                $('.menu-container').remove();
                ToastCustom({title: 'Successfully removed record', message: 'Successfully removed record', delay: 5000});
              },
              error(error) { 
                $('#' + updatedTableId).DataTable().ajax.reload();
                $('.menu-container').remove();
                ToastCustom({title: 'There was a problem', message: "There was a problem removing this record, please contact us for support", delay: 5000});
              }
            });
          }
        });
      });
    }

  });

  // Remove on click
  $('body').on('click', function (e) {

    // Set dropdown item
    let d = $('.table-menu, .action-dropdown');

    // Remove open class if clicked outside the dropdown
    if ( !d.is(e.target) && d.has(e.target).length === 0) {
      // d.removeClass('d-block');
      $('.table-menu').css('display', 'none').removeClass('d-block'); 
    }

  });

}
